(function () {
  'use strict';

  function setDisclosureState(container, trigger, isOpen) {
    if (!container || !trigger) {
      return;
    }

    container.classList.toggle('hide', !isOpen);
    container.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    trigger.classList.toggle('_open', isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function initBedzHeaderButtons() {
    var searchTrigger = document.querySelector('a.search-btn');
    var searchContainer = document.getElementById('search-container');

    var menuTrigger = document.querySelector('a.menu-btn');
    var menuContainer = document.getElementById('menu-container');

    if (searchTrigger && searchContainer) {
      searchTrigger.addEventListener('click', function (event) {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        var searchInput = searchContainer.querySelector(
          'input[type="search"]'
        );

        var isOpening = searchContainer.classList.contains('hide');

        setDisclosureState(
          searchContainer,
          searchTrigger,
          isOpening
        );

        if (isOpening && searchInput) {
          window.requestAnimationFrame(function () {
            searchInput.focus();
          });
        } else {
          if (
            searchInput &&
            document.activeElement === searchInput
          ) {
            searchInput.blur();
          }

          searchTrigger.focus();
        }
      });
    }

    if (menuTrigger && menuContainer) {
      menuTrigger.addEventListener('click', function (event) {
        if (!window.matchMedia('(max-width: 767px)').matches) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        var isOpening =
          menuContainer.classList.contains('hide');

        setDisclosureState(
          menuContainer,
          menuTrigger,
          isOpening
        );

        if (!isOpening) {
          menuTrigger.focus();
        }
      });
    }

    document.addEventListener('click', function (event) {
      if (
        window.matchMedia('(max-width: 749px)').matches &&
        searchContainer &&
        searchTrigger &&
        !searchContainer.classList.contains('hide') &&
        !searchContainer.contains(event.target) &&
        !searchTrigger.contains(event.target)
      ) {
        setDisclosureState(
          searchContainer,
          searchTrigger,
          false
        );
      }

      if (
        window.matchMedia('(max-width: 767px)').matches &&
        menuContainer &&
        menuTrigger &&
        !menuContainer.classList.contains('hide') &&
        !menuContainer.contains(event.target) &&
        !menuTrigger.contains(event.target)
      ) {
        setDisclosureState(
          menuContainer,
          menuTrigger,
          false
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initBedzHeaderButtons
    );
  } else {
    initBedzHeaderButtons();
  }
})();